<div class="master-modal upgrade-plan-modal" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Upgrade Plan</h4>
        <div class="modal_close_btn">
          <span (click)="dialogRef.close()" class="modal-close">
            <i class="material-icons">close</i>
          </span>
        </div>
      </div>

      <form [formGroup]="planForm" (ngSubmit)="onSubmit()" class="form-section">
        <perfect-scrollbar class="modal-body-scrollbar">
          <div class="modal-body pt-4">
            <!-- Current Plan Display -->
               <span class="current-badge" *ngIf="userSubscriptions.length">Current plan</span>
            <div class="current-plan-card" *ngIf="userSubscriptions.length">
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                <div class="plan-icon">
                  <mat-icon>emoji_events</mat-icon>
                </div>
                <div class="plan-details">
                  <div class="plan-name">{{currentSubscription?.subscription_plan?.name}}</div>
                  <div class="plan-expiry">Expires on:  {{currentSubscription?.expires_at | date}}</div>
                </div>
              
              </div>
            </div>

            <!-- Plan Selection -->
            <div class="custom-form-group">
              <label class="custom-label" for="">Select Upgrade/Downgrade Plan <span class="star">*</span></label>
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
               <mat-select placeholder="Select Plan" formControlName="selectedPlan" (selectionChange)="onPlanChange($event.value)">
                    <mat-option *ngFor="let plan of filteredPlans" [value]="plan">
                        {{ plan.name }} -   (AUD ${{ plan.monthy_price }}/M)
                    </mat-option>
                    </mat-select>
                  <mat-error *ngIf="planForm.get('selectedPlan')?.invalid">Please select a plan</mat-error>
                </mat-form-field>
              </div>
            </div>
 <!-- plan Details -->
            <div class="custom-form-group mb-3">
              <label class="custom-label" for="">Plan details</label>
               <div class="plan-details-box">
 
      <div  class="no-plan-selected">
        <div *ngIf="selectedPlan">
       

    <p *ngFor="let benefit of selectedPlan.benefits">{{benefit.name}}<br></p>
 
  </div>
      </div>
  
  </div>
 
            </div>
            <!-- Billing Type -->
            <div class="custom-form-group">
              <label class="custom-label" for="">Select Billing Type <span class="star">*</span></label>
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
          <mat-select placeholder="Select Billing Type" formControlName="billingType">
  <mat-option *ngIf="selectedPlan" value="monthly">
    Monthly — AUD ${{ selectedPlan?.monthy_price || 0 }}
  </mat-option>
  <mat-option *ngIf="selectedPlan" value="yearly">
    Yearly — AUD ${{ selectedPlan?.yearly_price || 0 }}
  </mat-option>
</mat-select>
                  <mat-error *ngIf="planForm.get('billingType')?.invalid">Please select billing type</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
        </perfect-scrollbar>

        <!-- Footer -->
        <div class="modal-footer mt-0 pt-0">
          <div mat-dialog-actions class="modal_footer center-footer">
         
            <button type="submit" mat-button class="modal-save-btn global-btn modal-footer-btn" [disabled]="planForm.invalid">
              <span>Continue</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
